import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VForm,[_c(VCheckbox,{attrs:{"label":_vm.t('employee.employeeExport')},model:{value:(_vm.model.export),callback:function ($$v) {_vm.$set(_vm.model, "export", $$v)},expression:"model.export"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }